import type {ReferralJob} from 'src/types/referral-v2';
import type {JobResponse} from 'src/types/referral-external';
import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {useSelector} from 'react-redux';
import {
  Button,
  SubTitleSmall,
  TitleMedium,
  Chip,
  Icon,
  PanelBody,
  PanelFooter,
  CircularLoader,
} from '@spaced-out/ui-design-system/lib/components/index';
import css from 'src/components/referral-external/jobs/jobs.css';


const JobDetails = ({
  setJobDetailsOpen,
  handleSelectJob,
  jobId,
  isDataLoading,
}: {
  setJobDetailsOpen?: (arg1: boolean) => void;
  handleSelectJob?: (arg1: ReferralJob) => void;
  jobId: string;
  isDataLoading: boolean;
}) => {
  const {jobs, job_description} = useSelector((state) => state.referrerPortal);
  const {t, makeKey} = useLabelTranslation();
  // @ts-expect-error - TS7006 - Parameter 'job' implicitly has an 'any' type.
  const job: JobResponse = (jobs || []).find((job) => job.id === jobId);

  const {
    id = jobId,
    job_type,
    payment_type,
    bonus,
    location,
    title,
  } = job || {};

  return (
    <>
      <PanelBody>
        <div className={css.jobDetailsBody}>
          {title ? <TitleMedium>{title}</TitleMedium> : null}
          {location ? (
            <div className={css.button}>
              <Icon
                color="tertiary"
                name="location-dot"
                size="medium"
                type="regular"
              />
              <SubTitleSmall color="secondary">{location}</SubTitleSmall>
            </div>
          ) : null}
          <div className={css.descriptionContainer}>
            <div className={css.chip}>
              {bonus && bonus.amount ? (
                bonus.currency === 'USD' ? (
                  <Chip
                    iconName="dollar"
                    semantic="secondary"
                    classNames={{wrapper: css.chipCursor}}
                  >
                    {`${bonus.amount} ${t('Bonus', 'Bonus')}`}
                  </Chip>
                ) : (
                  <Chip
                    semantic="secondary"
                    classNames={{wrapper: css.chipCursor}}
                  >{`${bonus.amount} ${t('Bonus', 'Bonus')}`}</Chip>
                )
              ) : null}
              {job_type ? (
                <Chip
                  iconName="briefcase"
                  semantic="secondary"
                  classNames={{wrapper: css.chipCursor}}
                >
                  {t(makeKey(job_type), job_type)}
                </Chip>
              ) : null}
              {payment_type ? (
                <Chip
                  iconName="wallet"
                  semantic="secondary"
                  classNames={{wrapper: css.chipCursor}}
                >
                  {t(makeKey(payment_type), payment_type)}
                </Chip>
              ) : null}
              <Chip semantic="secondary" classNames={{wrapper: css.chipCursor}}>
                {`${t('Job_ID', 'Job ID')}: `}
                {id}
              </Chip>
            </div>
          </div>
          {isDataLoading ? (
            <div className={css.loadingState}>
              <CircularLoader colorToken="colorFillPrimary" size="medium" />
            </div>
          ) : (
            <div
              className={css.description}
              dangerouslySetInnerHTML={{
                __html: job_description?.description || '<p></p>',
              }}
            />
          )}
        </div>
      </PanelBody>

      {handleSelectJob && (
        <PanelFooter>
          <div className={css.chip}>
            <Button
              onClick={() => {
                handleSelectJob({id, title});
                setJobDetailsOpen?.(false);
              }}
            >
              {t('Select', 'Select')}
            </Button>
          </div>
        </PanelFooter>
      )}
    </>
  );
};

export default JobDetails;
